<template>
  <div>
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row page-titles">
          <div class="col-md-5 align-self-center">
            <h4 class="text-themecolor">Statistic Reports</h4>
          </div>
          <div class="col-md-7 align-self-center text-right">
            <div class="d-flex justify-content-end align-items-center">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li class="breadcrumb-item active">Statistic Reports</li>
              </ol>
            </div>
          </div>
        </div>

        <div class="row justify-content-end">
          <div class="col-sm-4" style="margin-top: -18px !important">
            <!-- <label class="boldText" style="margin-bottom: 0px !important"
              >Users</label
            >
            <div>
              <Multiselect
                v-model="selectedUsers"
                mode="tags"
                placeholder="Select Users"
                :searchable="true"
                :createTag="true"
                :options="usersList"
              />
            </div> -->
          </div>

          <!-- <div class="col-sm-4" style="margin-top: -18px !important">
            <label class="boldText" style="margin-bottom: 0px !important"
              >Practices</label
            >
            <div>
              <Multiselect
                v-model="selectedPractice"
                placeholder="Select Users"
                :searchable="true"
                :createTag="true"
                :options="practices"
              />
            </div>
          </div> -->

          <div class="col-sm-4">
            <input
              style="margin-bottom: 6px; margin-left: 51px"
              type="text"
              name="daterangePR"
              :value="initDatePR"
              @change="datePickerPR"
              @focus="datePickerPR"
            />
            <div class="input-group-append">
              <span
                class="input-group-text"
                style="
                  position: absolute;
                  margin-top: -34px;
                  margin-left: 230px;
                "
              >
                <span class="ti-calendar"></span>
              </span>
            </div>
          </div>
        </div>
        <p></p>
        <div class="card p-3">
          <table
            data-height="300"
            class="
              table
              display
              table-bordered
              text-center
              table-striped
              no-wrap
            "
            id="example23"
          >
            <thead class="thead-dark">
              <tr>
                <th>Day</th>
                <th>Count</th>
                <th>Percent</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(vis, ndx01) in inData" :key="ndx01">
                <td>{{vis.dosStr}}</td>
                <td>{{vis.visits}}</td>
                <td>{{vis.percentage}}%</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- ============================================================== -->
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->
  </div>
</template>

<script>
import localMixin from "./Mixins/StatisticReport";
import moment from "moment";
import Multiselect from "@vueform/multiselect";
// import Swal from "sweetalert2";

export default {
  name: "StatisticReport",
  mixins: [localMixin],
  components: {
    // Multiselect,
  },

  data() {
    return {
        inData: [],
      users: [],
      practices: [],
      usersList: ["A", "B", "C", "D"],
      selectedUsers: [],

      selectedPractice: "",

      startDatePR: "",
      endDatePR: "",
      initDatePR: "",
      dummyDate: moment(String(new Date())).format("YYYY-MM-DD"),
    };
  }, // data
};
</script>

<style>
</style>